import type { IDropDownItem } from "@similarweb/ui-components";
import { Dropdown } from "@similarweb/ui-components";
import { StyledDropdownParent } from "app/pages/sales-intelligence/common-components/dropdown/styles";
import { buildDropdownSelectedItemsFromArray } from "app/pages/sales-intelligence/utils/dropdowns";
import FilterButtonLabel from "../shared/FilterDropdown/FilterButtonLabel/FilterButtonLabel";
import SignalFilterDropdownButton from "app/pages/sales-intelligence/sub-modules/signals/components/filters/shared/FilterDropdown/SignalFilterDropdownButton/SignalFilterDropdownButton";
import { DROPDOWN_HEIGHT, DROPDOWN_ID, DROPDOWN_WIDTH } from "./const";
import ThresholdListItem from "./ThresholdListItem/ThresholdListItem";

type FilterValue = number;

type DropdownItem = Omit<IDropDownItem, "id"> & {
    id: FilterValue;
};

type Props = {
    selectedValue: FilterValue | undefined;
    options: readonly number[];
    formatValue?(value: FilterValue | undefined): string;
    onValueChange(value: FilterValue): void;
};

const SignalTrafficThresholdFilter = (props: Props) => {
    const { selectedValue, options, formatValue, onValueChange } = props;

    const selectedItems: Record<FilterValue, boolean> = buildDropdownSelectedItemsFromArray(
        selectedValue ? [selectedValue] : [],
    );

    const getFormattedValue = (value: FilterValue | undefined): string => {
        if (typeof formatValue === "function") {
            return formatValue(value);
        }

        return `${value}`;
    };

    const handleClick = ({ id }: DropdownItem): void => {
        onValueChange(id);
    };

    return (
        <StyledDropdownParent id={DROPDOWN_ID}>
            <Dropdown
                appendTo={`#${DROPDOWN_ID}`}
                selectedIds={selectedItems}
                width={DROPDOWN_WIDTH}
                dropdownPopupHeight={DROPDOWN_HEIGHT}
                onClick={handleClick}
            >
                <SignalFilterDropdownButton id={DROPDOWN_ID}>
                    <FilterButtonLabel>{getFormattedValue(selectedValue)}</FilterButtonLabel>
                </SignalFilterDropdownButton>

                {...options.map((option) => (
                    <ThresholdListItem
                        key={option}
                        id={option}
                        text={getFormattedValue(option)}
                    />
                ))}
            </Dropdown>
        </StyledDropdownParent>
    );
};

export default SignalTrafficThresholdFilter;
